import { render } from "./SellerDashboard.vue?vue&type=template&id=437775e5&scoped=true"
import script from "./SellerDashboard.vue?vue&type=script&lang=js"
export * from "./SellerDashboard.vue?vue&type=script&lang=js"

import "./SellerDashboard.vue?vue&type=style&index=0&id=437775e5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-437775e5"]])

export default __exports__